import * as React from 'react';

export default class Welcome extends React.Component {
  render () {
    return (
      <>🗿Welcome!🗿</>
    );
  }
}
